import RouteItem from ".";
import PageUnderConstruction from "../pages/error-pages/PageUnderConstruction";
import StaffDetails from "../pages/administration/StaffDetails";

export const administrationRoutes: RouteItem = {
  key: "router-administration",
  title: "Administration",
  tooltip: "Administration",
  path: "/administration",
  enabled: true,
  component: <PageUnderConstruction />,
  appendDivider: true,
  subRoutesDirection: "horizontal",
  subRoutes: [
    {
      key: "router-staff-details",
      title: "Staff Details",
      tooltip: "Staff Details",
      path: "staff-details",
      component: <StaffDetails />,
      enabled: true,
      appendDivider: true,
    },
  ],
};
